module.exports = __webpack_public_path__ + "img/stock-fill.3426dc3f.svg";